export default __webpack_public_path__ + "static/media/lhd-interior-hero-desktop.278c3958.jpg";